import { Chip } from 'components/Chip/Chip'
import Styles from './ArrayInput.module.scss'
import { Close, Plus } from 'blaze-ui/icons'
import { forwardRef } from 'react'
import { ArrayInputProps } from 'blaze-ui/ArrayInput/Types'
import { useAddNewValue } from 'blaze-ui/ArrayInput/useAddNewValue'

export const ArrayInput = forwardRef<HTMLDivElement, ArrayInputProps>(
  ({ value, onChange, name, placeholder, chipClassName }, fRef) => {
    const addNewValue = useAddNewValue()

    const handleSubmit = (newValue: string) => {
      newValue.length > 0 && onChange(new Set([...Array.from(value), newValue]))
    }

    return (
      <div className={Styles.container} ref={fRef}>
        {Array.from(value).map((tag) => (
          <Chip
            variant="flat"
            key={tag}
            onPress={() => onChange(new Set(Array.from(value).filter((t) => t !== tag)))}
            deletable={false}
            isSelected={false}
            className={chipClassName}
          >
            {tag}
            <div className={Styles.delete}>
              <Close size={12} />
            </div>
          </Chip>
        ))}
        <Chip
          icon={Plus}
          deletable={false}
          onPress={() => addNewValue({ placeholder, onSubmit: handleSubmit, title: name })}
          aria-label={`Add New ${name}`}
          variant="button"
        >
          Add
        </Chip>
      </div>
    )
  },
)
